import { Button, Text } from "@solomon-labs/design/components/ui";
import React from "react";

interface AppErrorFallbackProps {
    error?: Error;
    retry: () => void;
}

export function AppErrorFallback({
    error: _error
}: AppErrorFallbackProps): React.ReactElement {
    return (
        <div className="flex min-h-dvh flex-col items-center justify-center px-6 bg-surface-ground">
            <div className="flex flex-col items-center text-center max-w-[420px]">
                <span className="font-numeric-mono font-bold tracking-tight text-foreground-base leading-none text-[8rem] md:text-[12rem] animate-not-found-hero">
                    !
                </span>

                <div className="w-16 md:w-24 h-[2px] bg-surface-inverse-raised mt-4 animate-not-found-divider" />

                <Text
                    variant="h2"
                    className="mt-4 text-foreground-base animate-not-found-heading"
                >
                    Something went wrong
                </Text>

                <Text
                    variant="body"
                    className="mt-1 text-foreground-neutral max-w-[32ch] animate-not-found-description"
                >
                    We hit an unexpected issue. Please try reloading the page.
                </Text>

                <div className="mt-8 animate-not-found-cta">
                    <Button
                        variant="raised"
                        size="sm"
                        interaction="lifted"
                        onClick={() => window.location.reload()}
                    >
                        Reload page
                    </Button>
                </div>
            </div>
        </div>
    );
}

export type { AppErrorFallbackProps };
